import React from 'react';
import { Gerenciar } from './Gerenciar';
import { Incluir } from "./Incluir";
import { useApp } from "../../../../context/app";

export const ManutencaoApp = () => {
    const { renderIncludeScreen } = useApp();
    
    return renderIncludeScreen ? ( <Incluir /> ) : ( <Gerenciar /> );
};
